import { createSelector } from 'reselect';
import { RootState } from '../../store';
import { IRegionPublicWaterSystemResult, ICountyPublicWaterSystemResult } from '../../../types';

const getRegionsViolationData = (state: RootState): IRegionPublicWaterSystemResult[] => 
  state.waterSystemAggregates.regionsViolations || [];
const getCountiesViolationData = (state: RootState): ICountyPublicWaterSystemResult[] => 
  state.waterSystemAggregates.countiesViolations || [];
const getZoomLevel = (state: RootState): string => state.waterSystemAggregates.zoomLevel;
const getLoading = (state: RootState) => state.waterSystemAggregates.loading;

export const selectRegionsViolations = createSelector(
  [getRegionsViolationData],
  (data) => {
    return data.filter(Boolean).map(region => ({
      ...region,
      epaRegion: parseInt(region.epaRegion, 10).toString(),
      id: `region-${parseInt(region.epaRegion, 10)}`,
      totalViolations: region.violations || 0,
      hasViolations: Boolean(region.violations)
    }));
  }
);
  
export const selectCountiesViolations = createSelector(
  [getCountiesViolationData],
  (data) => {
    return data.filter(Boolean).map(county => ({
      ...county,
      id: `county-${county.county_name}`,
      totalViolations: county.violations || 0,
      hasViolations: Boolean(county.violations)
    }));
  }
);

export const makeZoomLevel = createSelector(
  [getZoomLevel],
  (zoomLevel) => zoomLevel?.toLowerCase() || 'default'
);

export const WaterSystemsAggregateSelector = {
  selectRegionsViolations,
  selectCountiesViolations,
  makeZoomLevel,
  getLoading,
};
